import { styled } from "@mui/material/styles";
import {
  LinearProgress as MuiLinearProgress ,
  LinearProgressProps as MuiLinearProgressProps
} from "@mui/material";

import {LinearProgressProps} from '../types';

export const StyledLinearProgress= styled(MuiLinearProgress, {
  shouldForwardProp: (prop) => ![ 'height'].includes(String(prop)),
})<LinearProgressProps>(({ theme, color, height}) => ({
  height: height,
  borderRadius: `3px`,
  backgroundColor: `#e2e2e2`,
  '> span': {
    borderRadius: `3px`,
  },
  ...(!color  &&{
    '> span': {
      borderRadius: `3px`,
      background: "linear-gradient(to right, #8346ff, #2763ea)"
    },
  }),
  ...(color === 'inherit' && {
    '&:before': {
      content: `none`
    },
    '> span': {
      opacity: 1,
      borderRadius: `3px`,
      background: "linear-gradient(to right, #8346ff, #2763ea)"
    },
  })
}));
